import React, { useState, useEffect } from "react";
import { Box, Card, Select, ListItemText, MenuItem } from "@material-ui/core";
import { userHasSomePermissions } from "../util/permissionsUtils";
import { PermissionIdEnum } from "../util/types/permissions/permissionIdEnum";

export const MapLayersSelector = ({ currentIndex, setCurrentIndex, layersList, topPx = 250 }) => {
  const menuStyle = {
    position: "absolute",
    top: topPx,
    left: 0,
    padding: "10px",
  };

  const containerStyles = {
    maxHeight: "380px",
    overflowY: "auto",
  };

  const [localLayersList, setLocalLayersList] = useState({});

  useEffect(() => {
    const currLayers = {};

    Object.keys(layersList).map((riskLayerName) => {
      const layer = layersList[riskLayerName];

      if (
        !layer.permissions ||
        (layer.permissions.length && userHasSomePermissions([...layer.permissions, PermissionIdEnum.Super]))
      ) {
        currLayers[riskLayerName] = {
          ...layer,
        };
      }
    });

    setLocalLayersList(currLayers);
  }, []);

  const [openSelect, setOpenSelect] = useState(false);

  const getSelectValue = (selectedValue) => (
    <Box ml={1}>
      <ListItemText primary={layersList[selectedValue].label}></ListItemText>
    </Box>
  );

  return (
    <Box style={menuStyle}>
      <Card>
        <Select
          value={currentIndex}
          open={openSelect}
          onClose={() => setOpenSelect(false)}
          onOpen={() => setOpenSelect(true)}
          onChange={(e) => {
            setCurrentIndex(e.target.value);
          }}
          renderValue={(value) => getSelectValue(value)}
          MenuProps={{
            PaperProps: {
              style: containerStyles,
            },
          }}
        >
          {Object.keys(localLayersList).map((riskLayerName, index) => {
            return (
              <MenuItem key={index} value={riskLayerName}>
                {getSelectValue(riskLayerName)}
              </MenuItem>
            );
          })}
        </Select>
      </Card>
    </Box>
  );
};
